// 커뮤니티 관련 boards CRUD 및 fetch api 함수 파일
import { boards } from './index'

// 공통 필터 메서드 적용 
import { checkLimitedUser } from './function/method'

function fetchTabList() {
  return boards.post('tabList.do', {
    searchType: "community",
  }).then((res) => {
    return checkLimitedUser(res)
  })
}

function fetchWriteCommunityTabList() {
  return boards.post('writeCommunityBoardList.do', {})
  .then((res) => {
    return checkLimitedUser(res)
  })
}

function fetchNoticeList(option) {
  return boards.post('noticeList.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  })
}

function fetchSelectedBoardList(option) {
  return boards.post('selectBoardList.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  })
}

function fetchSelectBestList (option) {
  return boards.post('selectBestList.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  })
}

function fetchBoardDetail(option) {
  return boards.post('selectBoardDetail.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  })
}

function fetchCommentList(option) {
  return boards.post('selectBoardCommentList.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  })
}

function addComment(option) {
  return boards.post('insertComment.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  })
}

function updateComment(option) {
  return boards.post('updateComment.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  })
}

function deleteComment(option) {
  return boards.post('deleteComment.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  })
}

function likeBoard(option) {
  return boards.post('like.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  })
}

function commentLike(option) {
  return boards.post('commentLike.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  })
}

function insertBoard(option) {
  return boards.post('insertBoard.do', option, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  .then((res) => {
    return checkLimitedUser(res)
  })
}

function updateBoard(option) {
  return boards.post('updateBoard.do', option, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  .then((res) => {
    return checkLimitedUser(res)
  })
}

function deleteFile(option) {
  return boards.post('selectBoardFileDelete.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  })
}

function deleteBoard(option) {
  return boards.post('deleteBoard.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  })
}

function fetchMyLikeList(option) {
  return boards.post('myLikeList.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  })
}

function fetchMyPostList(option) {
  return boards.post('myPostList.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  })
}

function fetchMyCommentList(option) {
  return boards.post('myCommentList.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  })
}

function reportCommunityBoard(option) {
  return boards.post('report.do', option) 
  .then((res) => {
    return checkLimitedUser(res)
  })
} 

export { fetchTabList, fetchNoticeList, fetchSelectedBoardList, fetchWriteCommunityTabList,
         fetchBoardDetail, fetchCommentList, likeBoard, addComment, updateComment, deleteComment, insertBoard, deleteBoard, updateBoard, deleteFile, commentLike,
         fetchMyLikeList, fetchMyPostList, fetchMyCommentList, fetchSelectBestList, reportCommunityBoard }
